import React from "react";
import AdminDataTable from "components/AdminDataTable/AdminDataTable";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Flex,
  Container,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  Button,
} from "@chakra-ui/react";
import { AiOutlineSearch } from "react-icons/ai";
import data from "./Users";

const ActiveUsers = () => {
  const history = useNavigate();
  const isLoading = false;
  const Users = data.data;

  const activatedUsers = Users.filter((user) => user.activated);

  const COLUMNS = [
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Nationality",
      accessor: "nationality",
    },
    {
      Header: "State",
      accessor: "state",
    },
    {
      Header: "Actived On",
      accessor: "activated_on",
    },
  ];
  return (
    <Container mt="4" maxW="container.xl">
      <Flex justify={"space-between"} mt={"20px"} align="center">
        <Button
          variant="secondary"
          onClick={() => {
            history(-1);
          }}
        >
          Back
        </Button>

        <Text fontSize="20px" fontWeight="500">
          Active Users
        </Text>

        <Box
          display={{
            base: "none",
            lg: "block",
            xl: "block",
          }}
        >
          <InputGroup>
            <InputRightElement pointerEvents="none">
              <AiOutlineSearch color="gray.300" />
            </InputRightElement>
            <Input rounded="full" type="text" placeholder="Search" bg="white" />
          </InputGroup>
        </Box>
      </Flex>
      <Box p={"0 10px"} mt="2">
        <AdminDataTable
          ariaLabel="Active users"
          columns={COLUMNS}
          data={activatedUsers}
          loading={isLoading}
          paginate
          showRowNumbers
        />
      </Box>
    </Container>
  );
};

export default ActiveUsers;
